// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"95505b33","554":"3a3d3f1c","766":"9b1fa7ef","803":"3766a5d3"}[chunkId] + ".chunk.js";
};